import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Select from 'react-select'
import './ConciergeView.scss'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import mapboxgl from 'mapbox-gl'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

mapboxgl.accessToken = 'pk.eyJ1Ijoia2FydGlreWUtYXRoZWxhcyIsImEiOiJja2ZpbWRqcG8wNm1lMnFrdHExeDBtd3IzIn0.J5x_HtYWXZXchwLCdjejSw'

const localizer = momentLocalizer(moment)

const PATIENT = 'Patient'
const SITE = 'Site'
const START_TIME = 'StartTime'
const END_TIME = 'EndTime'
const RECURRENCE = 'Recurrence'
const OPERATOR = 'Operator'

class ScheduleAppointmentView extends React.Component {
  static defaultProps = {
    getPatients: _.noop,
    isFetchingPatients: true,
    getSites: _.noop,
    isFetchingSites: true,
    createAppointment: _.noop,
    getNearbyAppointments: _.noop,
    selectedSiteId: null,
    selectedPatientId: null,
    getUsers: _.noop,
    isFetchingUsers: true,
  }

  static propTypes = {
    getPatients: PropTypes.func,
    patients: PropTypes.object,
    isFetchingPatients: PropTypes.bool,
    getSites: PropTypes.func,
    sites: PropTypes.array,
    isFetchingSites: PropTypes.bool,
    createAppointment: PropTypes.func,
    getNearbyAppointments: PropTypes.func,
    selectedPatientId: PropTypes.integer,
    selectedSiteId: PropTypes.integer,
    getUsers: PropTypes.func,
    users: PropTypes.array,
    isFetchingUsers: PropTypes.bool
  }

  componentDidMount () {
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/streets-v9'
    })

    this.markers = []

    if (this.props.selectedSiteId && this.props.selectedPatientId) {
      this.handleSelect(SITE, { id: this.props.selectedSiteId }).then(() => {
        console.log('getting patient', this.props.patients)
        var patient = this.props.patients[this.props.selectedPatientId]
        patient.full_name = patient.first_name + ' ' + patient.last_name

        this.handleSelect(PATIENT, patient)
      })
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      selectedPatient: '',
      inputPatient: '',
      selectedStartTime: null,
      selectedEndTime: null,
      appointmentCreated: false,
      events: [],
      submitted: false,
      selectedOperator: null,
    }
  }

  checkPrereqs = () => {
    const { selectedStartTime, selectedEndTime } = this.state

    if (selectedStartTime < selectedEndTime) {
      return true
    }

    return false
  }

  handleSelect = (resourceType, selected) => {
    return new Promise((resolve) => {
      if (selected == null) {
        selected = ''
      }
      this.setState({ [`selected${resourceType}`]: selected })

      if (resourceType === OPERATOR && selected) {
        // TODO: Load operator's appointments
      }

      if (resourceType === SITE && selected) {
        this.props.getPatients(selected.id).then(resolve)
      }

      if (resourceType === START_TIME && selected) {
        this.setState({ [`selected${END_TIME}`]: selected })
      }

      if (resourceType === PATIENT && selected) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove()
        }

        this.map.easeTo({
          center: [selected.longitude, selected.latitude],
          zoom: 10
        })

        console.log(selected)

        var popup = new mapboxgl.Popup({ offset: 25 }).setText(
          `Patient ID: ${selected.id} - ${selected.first_name} ${selected.last_name}`
        )

        var el = document.createElement('div')
        el.className = 'mapbox-marker-selected'

        var marker = new mapboxgl.Marker(el)
          .setLngLat([selected.longitude, selected.latitude])
          .setPopup(popup)
          .addTo(this.map)

        this.markers.push(marker)

        /*this.props.getNearbyAppointments(selected.id).then((response) => {
          var nearbyPatients = response.data
          this.setState({'events': []})
          for (var i = 0; i < nearbyPatients.length; i++) {
            console.log(nearbyPatients[i])
            console.log(nearbyPatients[i].appointments[0].start)
            console.log(typeof nearbyPatients[i].appointments[0].start)

            this.setState({
              events: [...this.state.events, ...nearbyPatients[i].appointments]
            })

            popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
              <div>
                <p><b>Patient ID: ${nearbyPatients[i].id} - ${nearbyPatients[i].first_name} ${nearbyPatients[i].last_name}</b></p>
                <p>Appointment: ${nearbyPatients[i].appointments[0].start} - ${nearbyPatients[i].appointments[0].end}</p>
                <p>Appointment: ${nearbyPatients[i].appointments[1].start} - ${nearbyPatients[i].appointments[1].end}</p>
                <p>Appointment: ${nearbyPatients[i].appointments[2].start} - ${nearbyPatients[i].appointments[2].end}</p>
                <p>Appointment: ${nearbyPatients[i].appointments[3].start} - ${nearbyPatients[i].appointments[3].end}</p>
              </div>
              `
            )

            el = document.createElement('div')
            el.className = 'mapbox-marker-nearby'

            marker = new mapboxgl.Marker(el)
              .setLngLat([nearbyPatients[i].longitude, nearbyPatients[i].latitude])
              .setPopup(popup)
              .addTo(this.map)

            this.markers.push(marker)
          }
        })*/

        this.props.getNearbyAppointments(selected.id).then((response) => {
          if (response.error !== undefined) {
            return
          }

          var nearbyPatients = response.patients

          var events = response.events

          this.setState({ events: events })

          for (var i = 0; i < nearbyPatients.length; i++) {
            popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
              <div>
                <p>
                  <b>
                    Patient ID: ${nearbyPatients[i].id} - ${nearbyPatients[i].first_name} ${nearbyPatients[i].last_name}
                  </b>
                </p>
              </div>
              `
            )

            el = document.createElement('div')
            el.className = 'mapbox-marker-nearby'

            marker = new mapboxgl.Marker(el)
              .setLngLat([nearbyPatients[i].longitude, nearbyPatients[i].latitude])
              .setPopup(popup)
              .addTo(this.map)

            this.markers.push(marker)
          }
        })
      }
    })
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  handleSubmit = (event) => {
    const { selectedPatient, selectedStartTime, selectedEndTime, selectedRecurrence, selectedOperator } = this.state
    const { createAppointment } = this.props

    event.preventDefault()

    this.setState({ submitted: true })

    confirmAlert({
      title: 'Create Appointment?',
      message: `Create Appointment for ${selectedPatient.first_name} ${selectedPatient.last_name} from ${moment(selectedStartTime).format('hh:mm a')} on ${moment(selectedStartTime).format('MM/DD/YYYY')} to ${moment(selectedEndTime).format('hh:mm a')} on ${moment(selectedEndTime).format('MM/DD/YYYY')}`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            createAppointment(selectedPatient.id, moment(selectedStartTime).format('YYYY-MM-DDTHH:mm'),
              moment(selectedEndTime).format('YYYY-MM-DDTHH:mm'), selectedRecurrence.value,
              selectedOperator.user_id).then((response) => {
                this.setState({
                  appointmentCreated: true,
                  selectedPatient: '',
                  inputPatient: '',
                  selectedStartTime: null,
                  selectedEndTime: null,
                  selectedOperator: null
                })
              })
              .catch((e) => {
                console.error(e)
              })
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    })
  }

  render () {
    const { isFetchingSites, sites, isFetchingPatients, patients, isFetchingUsers, users } = this.props
    const { selectedPatient, selectedSite, selectedRecurrence,
      appointmentCreated, events, selectedOperator } = this.state

    var patientsArray = Object.values(patients)

    patientsArray.forEach((part, index) => {
      patientsArray[index].full_name = patientsArray[index].first_name + ' ' + patientsArray[index].last_name
    })

    console.log(users)

    return (
      <div className={'scheduler_view_container'}>
        <form className={'scheduler_view_form'}>
          { appointmentCreated ? (
            <div> Appointment Created! </div>
          ) : null}

          <div>
            Operator
          </div>

          <Select
            isSearchable
            isClearable
            isLoading={isFetchingUsers}
            options={users}
            value={selectedOperator}
            onChange={(selected) => this.handleSelect(OPERATOR, selected)}
            onInputChange={(input) => this.handleInput(OPERATOR, input)}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            noResultsText={false}
            labelKey={'email'}
            valueKey={'id'}
          />

          <br />

          <div>Site</div>

          <Select
            isSearchable
            isClearable
            isLoading={isFetchingSites}
            options={sites}
            value={selectedSite}
            onChange={(selected) => this.handleSelect(SITE, selected)}
            onInputChange={(input) => this.handleInput(SITE, input)}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            noResultsText={false}
            labelKey={'name'}
            valueKey={'id'}
          />

          {patientsArray && patientsArray.length > 0
            ? (
              <div>
                <div>Patient</div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingPatients}
                  options={patientsArray}
                  value={selectedPatient}
                  onChange={(selected) => this.handleSelect(PATIENT, selected)}
                  onInputChange={(input) => this.handleInput(PATIENT, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'full_name'}
                  valueKey={'id'}
                  />
              </div>
            )
            : null
          }

          { selectedPatient
          ? (
            <div>
              <div>{selectedPatient.first_name} {selectedPatient.last_name}</div>
              {selectedPatient.address ? <div>{selectedPatient.address}</div> : 'Patient does not have an address'}
              <br />
              <div>Start Time:</div>
              <DatePicker
                selected={this.state.selectedStartTime}
                onChange={(selected) => this.handleSelect(START_TIME, selected)}
                showTimeSelect
                timeIntervals={15}
                timeFormat='p'
                dateFormat='Pp'
              />
              <br />
              <div>End Time:</div>
              <DatePicker
                selected={this.state.selectedEndTime}
                onChange={(selected) => this.handleSelect(END_TIME, selected)}
                showTimeSelect
                timeIntervals={15}
                timeFormat='p'
                dateFormat='Pp'
              />

              <br />
              <div>Recurrence:</div>
              <Select
                options={[
                  { label: 'Weekly', value: 'weekly' },
                  { label: 'Biweekly', value: 'biweekly' },
                  { label: 'Monthly', value: 'monthly' }
                ]}
                value={selectedRecurrence}
                onChange={(selected) => this.handleSelect(RECURRENCE, selected)}
                onInputChange={(input) => this.handleInput(RECURRENCE, input)}
                labelKey={'label'}
                valueKey={'value'}
                  />

              { this.state.selectedStartTime && this.state.selectedEndTime && this.state.selectedRecurrence
                ? (
                  <button className='btn btn-secondary'
                    onClick={(e) => this.handleSubmit(e)}
                    disabled={!this.checkPrereqs}>
                    Create Event
                  </button>
                )
                : null
              }
            </div>

          )
           : null
          }
        </form>
        <div className={'scheduler_view_right_bar'}>
          <div ref={el => this.mapContainer = el} className={'scheduler_view_map'} />
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor={(event) => {
              return new Date(event.start)
            }}
            endAccessor={(event) => {
              return new Date(event.end)
            }}
            titleAccessor={(event) => {
              return event.summary.substr(24)
            }}
            tooltipAccessor='summary'
            style={{ height: 800 }}
            eventPropGetter={(event, start, end, isSelected) => {
              if (event.nearby) {
                return { style: { backgroundColor: '#f96284' } }
              } else {
                return { style: { backgroundColor: 'grey' } }
              }
            }}
          />
        </div>
      </div>
    )
  }
}

export default ScheduleAppointmentView



// WEBPACK FOOTER //
// ./src/routes/Concierge/components/ScheduleAppointmentView.jsx